import { playgroundApi } from '../../common/api-client';
import { BaseSavingsInsuranceResponse } from '../_shared';
import { FamilySavingsInsuranceFormValues } from './schema';

export const PRODUCT = 'FAMILY_SAVINGS_INSURANCE';

export type FamilySavingsInsuranceResponse = BaseSavingsInsuranceResponse;

export interface SimulateParams {
  values: FamilySavingsInsuranceFormValues;
}

export async function simulateFamilySavingsInsurance({
  values,
}: SimulateParams): Promise<FamilySavingsInsuranceResponse> {
  const payload = { product: PRODUCT, origin_process_id: `playground-${crypto.randomUUID().slice(0, 8)}`, ...values };
  const { data } = await playgroundApi.post<FamilySavingsInsuranceResponse>(
    'projection/',
    payload,
  );
  return data;
}
